import { useTranslation as useI18nTranslation } from 'react-i18next'

export function useTranslation(namespace: string | string[] = 'common') {
  const { t, i18n } = useI18nTranslation(namespace)

  return {
    t,
    i18n,
    language: i18n.language,
    changeLanguage: (lng: string) => i18n.changeLanguage(lng),
    isRTL: ['ar-SA', 'he-IL', 'fa-IR'].includes(i18n.language),
  }
}
